/* A pipe to format unix dates in a human-readable format using Moment.js
 * It takes a date in milliseconds and returns a formatted string.
 * @param date - The date in milliseconds to format.
 * @param format - The format string to use (default is 'DD/MM/YYYY HH:mm').
 * @returns The formatted date string.
 */

import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'formatDate',
  pure: true,
  standalone: false,
})
export class DatePipe implements PipeTransform {
  transform(date: number | string, format: string = 'DD/MM/YYYY HH:mm'): string {
    if (!date) {
      return '';
    }
    // check if date is unix timestamp
    if (typeof date === 'number' && date < 10000000000) {
      // Convert seconds to milliseconds
      date *= 1000;
    }
    // If date is a string format it directly
    if (typeof date === 'string' && !isNaN(Date.parse(date))) {
      date = new Date(date).getTime();
    }
    return moment(date).format(format);
  }
}
